<template>
  <div>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      :show-close="false"
      :modal-append-to-body="false"
      class="dialog-Individuation"
    >
      <p
        style="line-height: 25px;text-indent: 2rem;"
        v-if="fromObj.expiredStatus == 3"
      >
        您好，贵单位在易派客易竞拍专区的处置权限已过期，如需继续使用，请重新开通处置权限。
      </p>
      <p v-else>
        您还没有权限，请开通联系相关人员开通
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="close">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="权限到期提醒"
      :visible.sync="dialogVisiblePermission"
      width="600px"
      :show-close="false"
      :modal-append-to-body="false"
      class="dialog-Individuation"
    >
      <p style="line-height: 25px;text-indent: 2rem;">
        您好，贵单位在易派客易竞拍专区的处置权限还有<span style="color: red;"
          >{{ expiredDays }}天</span
        >（时间具体根据倒数的情况确定）到期，为避免影响后续使用，请尽快续签处置权限协议。
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="onRenewal">续签</el-button>
        <el-button type="primary" @click="dialogVisiblePermission = false"
          >取消</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="公告审批流设置提示"
      :visible.sync="dialogVisibleV"
      width="30%"
      :modal-append-to-body="false"
    >
      <div v-if="isAdmindialog">
        <p>
          开展业务前，需设置处置公告审批流，<span class="link" @click="link"
            >去设置</span
          >
        </p>
        <br />
        <p>公告审批流设置后，如需调整可点击菜单“公告审批设置”修改</p>
      </div>
      <div v-else>
        <p>需配置公告审批，请联系您公司系统管理员进行配置</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogVisibleV = false"
          >关闭</el-button
        >
      </span>
    </el-dialog>
    <div class="account" v-if="showV">
      <div class="account-aside">
        <el-menu
          router
          :default-openeds="openeds"
          @select="onMenuSelect"
          :default-active="$route.meta.activeName"
        >
          <el-submenu index="1">
            <template slot="title">处置公告管理</template>
            <el-menu-item index="CompileMaterial">编制处置公告</el-menu-item>
            <el-menu-item index="OurMaterial">我的处置公告</el-menu-item>
            <el-menu-item index="ExaminaMaterial" v-if="auditerWhether == 1"
              >审批处置公告</el-menu-item
            >
          </el-submenu>
          <el-submenu index="8">
            <template slot="title">委托处置管理</template>
            <el-menu-item index="EntrustedDisposal">我的委托处置</el-menu-item>
            <el-menu-item index="CommissionAnnouncement"
              >我的委托公告</el-menu-item
            >
            <el-menu-item
              index="EntrustedDisposalConfim"
              v-if="auditerWhether == 1"
              >审批委托处置</el-menu-item
            >
            <el-menu-item
              index="CommissionAnnouncementConfim"
              v-if="auditerWhether == 1"
              >审批委托公告</el-menu-item
            >
          </el-submenu>
          <el-submenu index="7">
            <template slot="title">处置异常管理</template>
            <el-menu-item index="UnusualHandle">处置异常处理</el-menu-item>
            <el-menu-item index="UnusualApprove" v-if="auditerWhether == 1"
              >处置异常审批</el-menu-item
            >
          </el-submenu>
          <el-submenu index="2">
            <template slot="title">订单管理</template>
            <el-menu-item index="OrderManagement">我的订单</el-menu-item>
            <el-menu-item index="IncompleteShipping"
              >未完成发货说明</el-menu-item
            >
          </el-submenu>
          <el-submenu index="3">
            <template slot="title">处置台账查询</template>
            <el-menu-item index="ParameterAnnouncement"
              >处置公告台账</el-menu-item
            >
            <!-- <el-menu-item index="EntrustedLedger">委托处置台账</el-menu-item> -->
            <!-- <el-menu-item index="ParameterOrder">我的订单台账</el-menu-item> -->
          </el-submenu>
          <el-submenu index="4" v-if="isAdminFlag">
            <template slot="title">公告审批设置</template>
            <el-menu-item index="ApprovalMateriail">公告审批设置</el-menu-item>
          </el-submenu>
          <el-submenu index="5">
            <template slot="title">资金账户管理</template>
            <el-menu-item index="AccountManagement">资金账户管理</el-menu-item>
          </el-submenu>
          <el-submenu index="6">
            <template slot="title">须知和协议</template>
            <el-menu-item index="Instructions">查看须知和协议</el-menu-item>
          </el-submenu>
        </el-menu>
      </div>
      <div class="account-container" v-cloak>
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Default',
  components: {},
  directives: {},
  filters: {},
  mixins: {},
  props: {
    propName: {
      // type: number,
      // default: 0
    }
  },
  data() {
    return {
      dialogVisiblePermission: false,
      dialogVisibleV: false,
      isAdminFlag: true,
      isAdmin: null,
      isAdmindialog: true,
      dialogVisible: false,
      auditerWhether: '',
      openeds: ['1', '2', '3', '4', '5', '6', '7', '8'],
      active: '',
      falg: true,
      showV: true,
      expiredDays: '',
      fromObj: {},
      formPath: false
      // key: value
    }
  },
  computed: {
    logo() {
      return this.$route.query.logo
    }
  },
  watch: {},
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (from.path == '/') {
        vm.formPath = true
      }
    })
  },
  created() {
    this.onMenuSelect()
    this.disposal()
  },
  methods: {
    close() {
      this.dialogVisible = false
      this.$router.push({ name: 'Notice' })
    },
    async disposal() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      })
      let data = await this.$api.materialdisposal.sellerApplycheck()
      this.fromObj = data
      loading.close()
      if (data) {
        this.sellerAuditGet()
      }
      if (data.applyStatus === 3 && data.expiredStatus != 3) {
        this.showV = true
      } else {
        this.showV = false
        this.dialogVisible = true
      }
      if (
        data.expiredStatus == 2 &&
        data.renewalStatus != 1 &&
        data.renewalStatus != 3 &&
        data.renewalStatus != 4 &&
        this.formPath
      ) {
        this.expiredDays = data.expiredDays
        this.dialogVisiblePermission = true
      }
      this.auditerWhether = data.auditerWhether
      this.isAdmin = data.isAdmin
      if (data.isAdmin === 0) {
        this.isAdminFlag = false
      }
    },
    onRenewal() {
      this.dialogVisiblePermission = false
      this.$router.push({ name: 'Instructions' })
    },
    async sellerAuditGet() {
      let data = await this.$api.materialdisposal.sellerAuditGet()
      if (data) {
        if (data.auditLevel === null) {
          if (this.isAdmin === 0) {
            this.isAdmindialog = false
          } else {
            this.isAdmindialog = true
          }
          this.dialogVisibleV = true
        } else {
          this.dialogVisibleV = false
        }
      }
    },
    link() {
      this.$router.push({ name: 'ApprovalMateriail' })
    },
    onMenuSelect(index) {
      this.active = index
    }
  }
}
</script>
<style lang="less">
.account {
  display: flex;
  margin-top: 20px;
  .el-submenu__title i {
    color: #ffffff;
  }
  .account-aside {
    width: 18%;
    padding-bottom: 40px;
    margin-right: 20px;
    .el-menu {
      border-right: none;
      .el-submenu__title {
        background: #2587ff;
        height: 40px;
        line-height: 40px;
        color: #ffff;
      }
      .el-menu-item {
        height: 40px;
        line-height: 40px;
      }
    }
  }
  .account-container {
    // width: 100%;
    // flex: 1;
    width: 80%;
    min-height: calc(100vh - 315px);
    // padding: 40px 30px;
  }
}
.link {
  color: cornflowerblue;
  cursor: pointer;
}
[v-cloak] {
  display: none;
}
</style>
